<template>

  <div class="settings scrollbar settings-authenticator">
    <div class="settings-header">
      <button type="button" class="history-back" @click="previous">
        <arrow-left-icon></arrow-left-icon>
      </button>
      Offline settings

    </div>

    <!--Only show when templateId available-->

    <hr class="settings-divider"/>

    <button v-if="!offlineMode" type="button" class="block" @click="switchToOffline">
      <cloud-off-outline-icon></cloud-off-outline-icon>
      <span class="settings-text">
        Switch to offline mode
      </span>
    </button>

    <button v-if="offlineMode" type="button" class="block" @click="logoutUser">
      <cloud-outline-icon></cloud-outline-icon>
      <span class="settings-text">
        Login again for online mode
      </span>
    </button>

    <hr class="settings-divider"/>

    <form v-on:submit.prevent="storeNewEncryptKey" class="settings-body">

      <p>
        Enable storing encrypted authenticators, favorites and settings offline by a password of your choosing. </p>
      <p>If disabled, your session
        is limited to 20 minutes and you will be switched into offline mode. Disabling offline mode will also remove any
        offline stored data.</p>

      <div class="form-group row">
        <label class="col col-form-label" for="offline_key">Offline passphrase</label>

        <div class="col-7">

          <input type="password" class="form-control" id="offline_key"
                 @keyup.enter.prevent="storeNewEncryptKey"
                 v-model="newKey">
        </div>
      </div>

      <div class="d-flex">

        <button v-if="!okey" class="ml-auto btn purple darken-4 white-text px-4 z-depth-1" type="button"

                @click="storeNewEncryptKey" :disabled="!newKey">
          Enable offline
        </button>
        <button v-if="okey" class="ml-auto btn purple darken-4 white-text px-4 z-depth-1" type="button"

                @click="storeNewEncryptKey" :disabled="!newKey">
          Change passphrase
        </button>
      </div>

    </form>

    <div v-if="okey">

      <hr class="settings-divider"/>

      <button type="button" class="block" @click="deleteOfflineStore">
        <security-close-icon></security-close-icon>
        <span class="settings-text">
          Clear offline encrypted data
        </span>
      </button>
      <p class="text-muted pl-4">
        Please note: when in offline mode it is not possible to retrieve new authenticators, settings or favorites
        without first logging in again.</p>
    </div>


  </div>

</template>

<script>
  import EventHub from '@/events/event-hub';
  import {mapActions, mapGetters} from 'vuex';

  import * as Toastr from 'toastr';

  import DeleteIcon from "vue-material-design-icons/Delete";
  import ArrowLeftIcon from "vue-material-design-icons/ArrowLeft";
  import CloudOffOutlineIcon from "vue-material-design-icons/CloudOffOutline";
  import SecurityCloseIcon from "vue-material-design-icons/SecurityClose";
  import CheckboxMarkedIcon from "vue-material-design-icons/CheckboxMarked";
  import CheckboxMarkedOutlineIcon from "vue-material-design-icons/CheckboxMarkedOutline";
  import CloudOutlineIcon from "vue-material-design-icons/CloudOutline";

  Toastr.options.timeout = 1500;

  export default {
    name: 'offline-settings',
    components: {
      CloudOutlineIcon,
      CheckboxMarkedOutlineIcon,
      CheckboxMarkedIcon,
      SecurityCloseIcon,
      CloudOffOutlineIcon,
      ArrowLeftIcon,
      DeleteIcon
    },
    data() {
      return {
        newKey: '',
      };
    },
    computed: {
      ...mapGetters({
        offlineMode: 'auth/offlineMode',
        okey: 'settings/okey',
      }),
    },
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        setOfflineMode: 'auth/setOfflineMode',
      }),
      switchToOffline() {
        if (confirm("Enabling offline-mode will disable retrieving new authenticators, settings or storing your preferences. Are yous sure?")) {// eslint-disable-line no-alert
          this.setOfflineMode(true);
        }
      },
      logoutUser() {
        this.logout()
          .then(() => {
            this.$router.push({name: 'login', query: {in: 1}});
            //return document.location.reload();
          });
      },
      previous() {
        return this.$router.push({name: 'settings'});
      },
      showHelp() {
        EventHub.$emit('help-show');
      },
      showDisclaimer() {
        EventHub.$emit('disclaimer-show');
      },
      showPrivacy() {
        EventHub.$emit('privacy-show');
      },
      postPersonalPreferences(e) {
        e.preventDefault();
        if (!this.offlineMode && this.personalFolderId) {

          this.fetching = true;
          this.postPreferences()
            .then(response => {
              if (typeof response == "undefined") {
                return Toastr.error('Unable to save settings.');
              }
              return Toastr.success('Settings and favorites saved.');

            })
            .catch(() => {
              return Toastr.error('Unable to save settings.');
            })
            .finally(() => {
              this.fetching = false;
            });
        }
      },
      refreshAuthenticators(e) {
        e.preventDefault();
        this.fetching = true;
        this.$store.dispatch('authenticators/clearAll');
        this.$store.dispatch('asyncData')
          .then(() => {
            return Toastr.success('Authenticators retrieved.');
          })
          .catch(() => {
            return Toastr.error('Unable to fetch authenticators.');
          })
          .finally(() => {
            this.fetching = false;
          });
      },
      getPersonalPreferences(e) {
        e.preventDefault();

        if (!this.offlineMode && this.personalFolderId) {
          this.fetching = true;
          this.getPreferences(true)
            .then(result => {
              if (result == 0) {
                return Toastr.info('No settings found.');
              }
              if (typeof result !== 'undefined' && result >= 1) {
                this.form.offline = true;
                return Toastr.success('Settings and favorites loaded.');
              }
            })
            .finally(() => {

              this.fetching = false;
            });
        }
      },
      deleteOfflineStore() {
        if (confirm("Do you want to remove your offline data?")) { // eslint-disable-line no-alert
          this.$store.commit('settings/setOkey', null);
          this.$store.commit('settings/setStoreOffline', false);
          localStorage.removeItem('store');
          if (!this.okey) {
            if (this.offlineMode) {
              this.logoutUser();
            }
            Toastr.success('Store and offline key removed');
          }
        }
      },
      storeNewEncryptKey() {
        if (this.newKey !== '') {
          this.$store.commit('settings/setStoreOffline', true);
          this.$store.commit('settings/encryptOkey', this.newKey);
          this.newKey = '';
          if (this.okey) {
            Toastr.success('Offline encrypted re-enabled');
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/settings/OfflineSettings.vue